import { render, staticRenderFns } from "./ExhibitionSearch.vue?vue&type=template&id=8144b424&"
import script from "./ExhibitionSearch.vue?vue&type=script&lang=js&"
export * from "./ExhibitionSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports